import React, { useEffect, useState } from 'react'
import JC from '../media/JC.png'
import { Navigate, useNavigate } from 'react-router-dom'
import { Grid, Typography } from '@mui/material';
import { getVersion } from '../services/apis';
import { use } from 'react';
import { useLocation } from 'react-router-dom';

export const Footer = () => {
    const navigate = useNavigate();
    const location = useLocation();
    //---------------------------------------------------------------------------------------
    //---------------------------------------------------------------------------------------
    //---------------------------------------------------------------------------------------
    //--IMPORTANTE CAMBIAR LA VERSION AQUI Y EN LA TABLA version EN LA BBDD
    //---------------------------------------------------------------------------------------
    //---------------------------------------------------------------------------------------
    //---------------------------------------------------------------------------------------
    const [versionLocal, setVersionLocal] = useState('2.9.0.7');
    //---------------------------------------------------------------------------------------
    //---------------------------------------------------------------------------------------
    //---------------------------------------------------------------------------------------
    //---------------------------------------------------------------------------------------
    //---------------------------------------------------------------------------------------
    //---------------------------------------------------------------------------------------

    const [actualizado, setActualizado] = useState(false);

    const comprobarVersion = async (versionLocal) => {
        // console.log("Comprobando versión local:", versionLocal);

        try {
            const response = await getVersion(versionLocal);

            // console.log("Respuesta del servidor:", response);

            if (response.success && response.actualizar) {
                if (!actualizado) {
                    setActualizado(true);
                    actualizarApp();
                }
            }

        } catch (error) {
            console.error("Error:", error);
        }
    }

    const actualizarApp = () => {
        // Paso 1: Enviar headers anti-caché (opcional)
        fetch(window.location.href, {
            headers: {
                'Cache-Control': 'no-cache',
                'Pragma': 'no-cache'
            }
        }).then(() => {
            // Paso 2: Recargar la página con un parámetro único
            window.location.href = window.location.href.split('?')[0] + '?updateApp=' + Date.now();
        });
    };

    useEffect(() => {
        comprobarVersion(versionLocal);
    }, [location.pathname]);

    return (
        <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            xs={12}
            gap={1}
            className='footer'
        >
            <img src={JC} alt="" style={{ maxWidth: '200px' }} onClick={() => window.open("https://www.jcinformatics.com/", "_blank")} />
            <Typography variant='caption'>&nbsp;Alpha {versionLocal}</Typography>
        </Grid>
    )
}
